import { number } from 'fp-ts';
import { Optional } from '@mews/std';

export const isValidOccupancyCount = (count: Optional<number>): count is number => number.isNumber(count) && count >= 0;

export const areBothOccupanciesZero = (adultCount: Optional<number>, childCount: Optional<number>) =>
    isValidOccupancyCount(adultCount) && adultCount === 0 && isValidOccupancyCount(childCount) && childCount === 0;
